module.exports = __webpack_public_path__ + "images/cool-sunglasses-gif.gif";